import { Follower } from "@scrile/api-provider/dist/api/FollowingsProvider";

export type FollowersMap = Record<Follower["userId"], Follower>;

export enum FollowersPageTabs {
  SUBSCRIBERS = "subscribers",
  FOLLOWERS = "followers",
  FOLLOWING = "following",
}
